export default __webpack_public_path__ + "static/news16-3812bbded3c10fcac2f7b19f958c2f05.jpeg";